import React, { useState } from 'react'
import * as PropTypes from 'prop-types'

const BottomDrawerContext = React.createContext([null, () => {}])

const BottomDrawerProvider = ({ children }) => {
  const [contentRef, setContentRef] = useState(null)

  return (
    <BottomDrawerContext.Provider value={[contentRef, setContentRef]}>
      {children}
    </BottomDrawerContext.Provider>
  )
}

BottomDrawerProvider.propTypes = {
  children: PropTypes.shape({}),
}
BottomDrawerProvider.defaultProps = {
  children: [],
}

export { BottomDrawerContext, BottomDrawerProvider }
